<template>
    <div :class="[loadingSpinner]" class="d-flex flex-column p-2 gap-2 align-items-center">
        <div class="custom-spinner" :class="`custom-spinner-${size}`" role="status">
            <div class="logo-spinner"></div>
            <span class="visually-hidden">{{ $t('Loading...') }}</span>
        </div>
        <span v-if="text" class="text-">{{ text }}</span>
    </div>
</template>

<script setup>
import {computed} from "vue";
import {trans as $t} from "@/vue/composables/missingTranslations";

const props = defineProps({
    loading: { type: Boolean, default: false },
    text: { type: String },
    size: {type: String, default:'sm'}
})
const loadingSpinner = computed(() => {
    if (props.loading) {
        return 'visible'
    }
    return 'visually-hidden'
})
</script>

<style>
.custom-spinner {
    display: inline-block;
    position: relative;
}

.custom-spinner-sm {
    width: 50px;
    height: 50px;
}

.custom-spinner-md {
    width: 100px;
    height: 100px;
}

.custom-spinner-lg {
    width: 135px;
    height: 135px;
}

.logo-spinner {
    background-image: url('/img/spinner.png');
    background-size: cover;
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    animation: spin 2s linear infinite;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
</style>
